import amLogo from '@assets/svgs/am-logo.svg';
import { FC } from 'react';
import styled from 'styled-components';

export type AMCustomToastNotificationProps = {
  toastMessage: JSX.Element;
};

const AMCustomToastNotification: FC<AMCustomToastNotificationProps> = (props) => {
  return (
    <Wrapper data-testid='am-custom-toast'>
      <AMLogoImg src={amLogo} />
      {props.toastMessage}
    </Wrapper>
  );
};

export default AMCustomToastNotification;

const AMLogoImg = styled.img`
  height: 30px;
  width: 165px;
  margin-right: 15px;
  margin-top: 5px;
  border: none;
  outline: none;
`;

const Wrapper = styled.div`
  display: flex;
  margin-top: 5px;
`;
